import { useEffect } from "react";
import { ChevronLeft, ChevronRight, X } from "lucide-react";
import { IconButton } from "../../components/ui/Primitives.jsx";
import { getDisplayImageSrc, getDownloadImageSrc } from "../../lib/imageAssets.js";

export function GalleryLightbox({ item, hasPrev, hasNext, onClose, onNavigate }) {
  const src = getDownloadImageSrc(item) || getDisplayImageSrc(item);

  useEffect(() => {
    function handleKeyDown(event) {
      if (event.key === "Escape") {
        onClose();
        return;
      }
      if (event.key === "ArrowLeft" && hasPrev) {
        onNavigate("prev");
        return;
      }
      if (event.key === "ArrowRight" && hasNext) {
        onNavigate("next");
      }
    }
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [hasNext, hasPrev, onClose, onNavigate]);

  return (
    <div className="auth-overlay gallery-lightbox" role="dialog" aria-modal="true" aria-label="作品原图" onMouseDown={onClose}>
      <IconButton className="auth-close gallery-lightbox-close" aria-label="关闭作品预览" onClick={onClose}>
        <X size={18} aria-hidden="true" />
      </IconButton>
      {hasPrev ? (
        <IconButton
          className="gallery-lightbox-arrow gallery-lightbox-prev"
          aria-label="上一张作品"
          onMouseDown={(event) => event.stopPropagation()}
          onClick={(event) => {
            event.stopPropagation();
            onNavigate("prev");
          }}
        >
          <ChevronLeft size={28} aria-hidden="true" />
        </IconButton>
      ) : null}
      <div className="gallery-lightbox-stage" onMouseDown={(event) => event.stopPropagation()}>
        <img
          className="gallery-lightbox-image"
          src={src}
          alt={item.prompt || "生成作品原图"}
          loading="eager"
        />
      </div>
      {hasNext ? (
        <IconButton
          className="gallery-lightbox-arrow gallery-lightbox-next"
          aria-label="下一张作品"
          onMouseDown={(event) => event.stopPropagation()}
          onClick={(event) => {
            event.stopPropagation();
            onNavigate("next");
          }}
        >
          <ChevronRight size={28} aria-hidden="true" />
        </IconButton>
      ) : null}
    </div>
  );
}
